import { createSelector } from "reselect";
import { toSafeObject } from "../helpers/StateHelper";

const getLoggedUserProfile = (state) => {
    return state.session.get('profile')
}

export const getLoggedUserProfileSelector = createSelector(getLoggedUserProfile, (userProfile) => toSafeObject(userProfile))